import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { AuthLayout } from '../components/auth';
import { FormField, Button } from '../components/forms';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3800';

const ForgotPasswordPage = () => {
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm();

  const handleForgotPassword = async (data) => {
    setSuccessMessage('');
    setIsSubmitting(true);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: data.email }),
      });

      if (!response.ok) {
        console.error(`Forgot password request failed with status ${response.status}`);
      }
    } catch (err) {
      // Silently ignore — always show success to prevent email enumeration
      console.error('Forgot password request error:', err);
    } finally {
      setSuccessMessage(
        'If an account exists for this email, a password reset link has been sent. Please check your inbox.'
      );
      setIsSubmitting(false);
    }
  };

  return (
    <AuthLayout
      title="Forgot Password"
      subtitle={
        <>
          Remembered your password?{' '}
          <Link to="/login" className="font-medium text-green-600 hover:text-green-500 underline">
            Sign in
          </Link>
        </>
      }
    >
      {successMessage ? (
        <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg">
          <p className="text-sm">{successMessage}</p>
          <Link
            to="/login"
            className="mt-3 inline-block text-sm font-medium text-green-600 hover:text-green-500 underline"
          >
            Back to Sign In
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit(handleForgotPassword)} className="space-y-6">
          <p className="text-sm text-gray-600">
            Enter your email address and we'll send you a link to reset your password.
          </p>

          <FormField
            label="Email Address"
            name="email"
            type="email"
            register={register}
            validation={{
              required: 'Email is required',
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: 'Please enter a valid email address',
              },
            }}
            error={errors.email}
            placeholder="your.email@example.com"
            required
          />

          <Button
            type="submit"
            loading={isSubmitting}
            className="w-full"
          >
            {isSubmitting ? 'Sending...' : 'Send Reset Link'}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
